import Renderer from "./Renderer";
import Designer from './Designer';
import CompSource from "./CompSource";
import UcWindow from "./UcWindow";
// import 'vue-popperjs/dist/vue-popper.css';
import { UICorePlugin } from './Plugin';
import AnyInput from './builtin/designerComponents/AnyInput';
import * as EditorComps from './comps';
import * as utils from './utils';
import * as helpers from './helpers';
import FlowAbortError from './simpleFlow/FlowAbortError';
import '../styles/deps';
import ExprInput from './comps/ExprInput';
import { ExprInputCompletionProvider } from './comps/ExprInput/ExprInputCompletionProvider';
import DataPathSelector from './builtin/designerComponents/DataPathSelector';
import DataSourceMethodSelector from './builtin/flowAtoms/paramsFormComponents/dataSourceMethodSelector';
import MethodArgumentsInput from './builtin/designerComponents/MethodArgumentsInput';
import AlternativeForDataSourcePopover from './comps/MaterialBox/AlternativeForDataSourcePopover';
import UndoManager from './exts/UndoManager';
import * as RendererUtils from './renderer/index';
import { UcSlot } from './ucBus/patchVueComponentSource/UcSlot';
import { UcScopedSlot } from './ucBus/patchVueComponentSource/UcScopedSlot';

/**
 * @param {typeof import('vue').default} Vue
 */
function install(Vue) {
  Vue.component('UcRenderer', Renderer);
  Vue.component('UcDesigner', Designer);
  Vue.component('UcCompSource', CompSource);
  Vue.component('UcWindow', UcWindow);
  Vue.component('UcExprInput', ExprInput);
  Vue.component('UcExprInputCompletionProvider', ExprInputCompletionProvider);
  Vue.component('UcAnyInput', AnyInput);
}
export * from './defaults';
export * from './builtin';
export { ExprInput, ExprInputCompletionProvider };

// eslint-disable-next-line no-undef
export const version = "1.133.0";
export { install, utils, helpers, Renderer, Designer, CompSource, UcWindow, AnyInput, UICorePlugin, UICorePlugin as Plugin, FlowAbortError, DataPathSelector, DataSourceMethodSelector, MethodArgumentsInput, AlternativeForDataSourcePopover, EditorComps, UndoManager, RendererUtils, UcSlot, UcScopedSlot };
//# sourceMappingURL=exports.js.map
